import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import {
    getUserInfo,
    updateProfilePicture,
    updateUserInfo,
} from "../redux/userSpeaker/userSpeakerSlice";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import MyContacts from "./MyContacts";
import { getCompanyCategories } from "../redux/companyCategory/companyCategorySlice";
import { getLoggedInUserInfo } from "../redux/auth/authApi";
import AssignLocationComponent from "./AssignLocation/AssignLocationComponents";
import { processFileUpload, FILE_TYPES } from "../utils/fileUploadHelper";
import { getImageUrlHelper } from "../helper/helper";
import Select from "react-select";
import { countryCodes } from "../helper/countryCodes";
import { countryOptions, customStyles, formatOptionLabel } from "./CountryCode/helper";
import AssignSponsorComponent from "./AssignSponsor/AssignSponsorComponent";
const ViewProfileLayer = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { userInfo } = useSelector((state) => state.speaker);

    const [imagePreview, setImagePreview] = useState(
        "/assets/images/user-grid-img13.png"
    );
    const [selectedFile, setSelectedFile] = useState(null);

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [bannerPreview, setBannerPreview] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [portfolioPreview, setPortfolioPreview] = useState(null);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const loggedInUserInfo = getLoggedInUserInfo();

    const loggedInRole = loggedInUserInfo?.Role?.name;
    const selectedUserRole = userInfo?.Role?.name;
    const canAssignSponsors =
        (loggedInRole === "ADMIN" || loggedInRole === "SUPER_ADMIN") &&
        selectedUserRole === "SPONSOR";

    const [cropSrc, setCropSrc] = useState(null);
    const [crop, setCrop] = useState({
        unit: "%",
        width: 50,
        aspect: 1
    });
    const [completedCrop, setCompletedCrop] = useState(null);
    const [showCropModal, setShowCropModal] = useState(false);
    const [errors, setErrors] = useState({
        email: "",
        phone: "",
    });
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const imgRef = React.useRef(null);
    const [profileData, setProfileData] = useState({
        userName: "",
        phone: "",
        countryCode: "+91",
        email: "",
        country: "",
        city: "",
        linkedIn: "",
        twitter: "",
        instagram: "",
        facebook: "",
        website: "",
        companyCategoryId: "",
        companyCategory: "",
        companyName: "",
        designation: "",
        room: "",
        description: "",
        workPhone: "",
        workEmail: "",
        companyWebsite: "",
        companyAddress: "",
        allowed: 1,
        banner: null,
        portfolio: null,
    });
    useEffect(() => {
        setImagePreview("/assets/images/user-grid-img13.png");
        setBannerPreview(null);
        setPortfolioPreview(null);
        setLogoPreview(null);

        setProfileData({
            userName: "",
            phone: "",
            countryCode: "+91",
            email: "",
            country: "",
            city: "",
            linkedIn: "",
            twitter: "",
            instagram: "",
            facebook: "",
            website: "",
            companyCategoryId: "",
            companyCategory: "",
            companyName: "",
            designation: "",
            room: "",
            description: "",
            workPhone: "",
            workEmail: "",
            companyWebsite: "",
            companyAddress: "",
            allowed: 1,
            banner: null,
            portfolio: null,
        });

    }, [id]);

    const isSponsor = userInfo?.Role?.name === "SPONSOR";
    const isLoggedInSponsor = loggedInUserInfo?.Role?.name === "SPONSOR";

    useEffect(() => {
        if (id) dispatch(getUserInfo(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (userInfo?.profilePicture) {
            setImagePreview(`${process.env.REACT_APP_API_URL}/${userInfo.profilePicture}`);
        } else {
            setImagePreview("/assets/images/user-grid-img13.png");
        }
    }, [userInfo?.profilePicture]);

    const { categories } = useSelector((state) => state.companyCategory);

    useEffect(() => {
        if (!isLoggedInSponsor) {
            dispatch(getCompanyCategories());
        }
    }, [isLoggedInSponsor]);

    useEffect(() => {
        if (userInfo) {
            setProfileData((prev) => ({
                ...prev,
                userName: userInfo?.fullName || "",
                phone: userInfo?.phone || "",
                countryCode: userInfo?.countryCode || "+91",
                email: userInfo?.email || "",
                country: userInfo?.country || "",
                city: userInfo?.city || "",

                linkedIn: userInfo?.Social?.linkedIn || "",
                twitter: userInfo?.Social?.twitter || "",
                instagram: userInfo?.Social?.instagram || "",
                facebook: userInfo?.Social?.facebook || "",
                website: userInfo?.Social?.website || "",
                companyCategoryId: userInfo?.Company?.companyCategoryId || "",
                companyCategory: userInfo?.Company?.category?.name || "",

                companyName: userInfo?.Company?.name || "",
                designation: userInfo?.designation || "",
                description: userInfo?.Company?.description || "",
                workPhone: userInfo?.Company?.phone || "",
                workEmail: userInfo?.Company?.email || "",
                companyWebsite: userInfo?.Company?.website || "",
                companyAddress: userInfo?.Company?.address || "",
                room: userInfo?.Company?.room || "",

                allowed: userInfo?.Company?.allowed ?? 1,

            }));
            setBannerPreview(null);
            setPortfolioPreview(null);
            setLogoPreview(null);

            if (userInfo?.Company?.banner) {
                setBannerPreview(getImageUrlHelper(userInfo.Company.banner));
            }

            if (userInfo?.Company?.portfolio) {
                setPortfolioPreview(getImageUrlHelper(userInfo.Company.portfolio));
            }
            if (userInfo?.Company?.logo) {
                setLogoPreview(getImageUrlHelper(userInfo.Company.logo));
            }
        }
    }, [userInfo]);

    /* IMAGE PREVIEW */

    const handleImageSelect = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const processedFile = await processFileUpload(file, {
            allowedTypes: FILE_TYPES.IMAGE,
        });

        if (!processedFile) return;

        const reader = new FileReader();
        reader.onload = () => {
            setCropSrc(reader.result);
            setShowCropModal(true);
        };

        reader.readAsDataURL(processedFile);
    };

    const handleLogoChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const processedFile = await processFileUpload(file, {
            allowedTypes: FILE_TYPES.IMAGE,
        });

        if (!processedFile) return;

        setProfileData({
            ...profileData,
            logo: processedFile,
        });

        setLogoPreview(URL.createObjectURL(processedFile));
    };
    const handleCropUpload = async () => {

        if (!completedCrop || !imgRef.current) return;

        const canvas = document.createElement("canvas");
        const image = imgRef.current;

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        canvas.width = completedCrop.width;
        canvas.height = completedCrop.height;

        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            completedCrop.width,
            completedCrop.height
        );

        canvas.toBlob(async (blob) => {

            let file = new File([blob], "profile.jpg", { type: "image/jpeg" });

            file = await processFileUpload(file, {
                allowedTypes: FILE_TYPES.IMAGE,
            });

            if (!file) return;

            setImagePreview(URL.createObjectURL(file));

            try {
                await dispatch(updateProfilePicture({ id, file })).unwrap();
                toast.success("Profile picture updated");
            } catch (err) {
                toast.error("Upload failed");
            }

        });

        setShowCropModal(false);
    };

    /* PROFILE DATA CHANGE */

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            setProfileData({
                ...profileData,
                [name]: files[0],
            });
        } else {
            setProfileData({
                ...profileData,
                [name]: name === "allowed" ? Number(value) : value,
            });
        }

        // WORK PHONE (GLOBAL)
        if (name === "workPhone") {
            const numericValue = value.replace(/\D/g, "").slice(0, 15);

            setProfileData({
                ...profileData,
                workPhone: numericValue,
            });

            setErrors((prev) => ({
                ...prev,
                workPhone:
                    numericValue.length === 0
                        ? "Work phone is required"
                        : numericValue.length < 6
                            ? "Too short"
                            : numericValue.length > 15
                                ? "Too long"
                                : "",
            }));
            return;
        }
        if (name === "email") {
            setErrors((prev) => ({
                ...prev,
                email:
                    value.length === 0
                        ? "Email is required"
                        : !emailRegex.test(value)
                            ? "Enter a valid email"
                            : "",
            }));
        }
        // PHONE (GLOBAL)
        if (name === "phone") {
            const numericValue = value.replace(/\D/g, "").slice(0, 15);

            setProfileData({
                ...profileData,
                phone: numericValue,
            });

            setErrors((prev) => ({
                ...prev,
                phone:
                    numericValue.length === 0
                        ? "Phone is required"
                        : numericValue.length < 6
                            ? "Phone too short"
                            : numericValue.length > 15
                                ? "Phone too long"
                                : "",
            }));
            return;
        }

        if (name === "workEmail") {
            setProfileData({
                ...profileData,
                workEmail: value,
            });

            setErrors((prev) => ({
                ...prev,
                workEmail:
                    value.length === 0
                        ? "Work email is required"
                        : !emailRegex.test(value)
                            ? "Enter valid email"
                            : "",
            }));

            return;
        }
    };

    /* UPDATE PROFILE */

    const handleFileChange = async (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (!file) return;

        let allowedTypes = FILE_TYPES.ALL;

        if (name === "banner") {
            allowedTypes = FILE_TYPES.IMAGE;
        }

        if (name === "portfolio") {
            allowedTypes = [
                ...FILE_TYPES.IMAGE,
                ...FILE_TYPES.PDF,
                ...FILE_TYPES.PPT,
            ];
        }

        const processedFile = await processFileUpload(file, {
            allowedTypes,
        });

        if (!processedFile) return;

        setProfileData({
            ...profileData,
            [name]: processedFile,
        });

        const previewUrl = URL.createObjectURL(processedFile);

        if (name === "banner") setBannerPreview(previewUrl);
        if (name === "portfolio") setPortfolioPreview(previewUrl);
    };
    const handleUpdateProfile = async () => {
        try {
            const formData = new FormData();

            // append normal fields
            Object.keys(profileData).forEach((key) => {
                const value = profileData[key];

                // For logged-in sponsor, don't send disabled fields
                if (
                    isLoggedInSponsor &&
                    ["email", "phone", "countryCode"].includes(key)
                ) {
                    return;
                }

                if (
                    value !== null &&
                    value !== "" &&
                    !(value instanceof File) &&
                    key !== "banner" &&
                    key !== "portfolio"
                ) {
                    formData.append(key, value);
                }
            });
            if (profileData.allowed < 0) {
                return toast.error("Allowed must be 0 or greater");
            }
            if (!profileData.companyName || !profileData.designation) {
                return toast.error("Company Name & Designation are required");
            }
            if (profileData.allowed > 99) {
                return toast.error("Allowed cannot be more than 99");
            }
            if (!isLoggedInSponsor) {
                if (!emailRegex.test(profileData.email)) {
                    return toast.error("Enter a valid email");
                }

                if (!/^\d{6,15}$/.test(profileData.phone)) {
                    return toast.error("Enter valid phone number");
                }
            }

            // Only required for NON-SPONSOR users
            if (userInfo?.Role?.name == "SPONSOR" && !profileData.companyCategoryId) {
                return toast.error("Company category Id is required");
            }

            // append files ONLY if valid
            if (profileData.banner) {
                formData.append("banner", profileData.banner);
            }
            if (profileData.logo) {
                formData.append("logo", profileData.logo);
            }
            if (profileData.portfolio) {
                formData.append("portfolio", profileData.portfolio);
            }

            await dispatch(
                updateUserInfo({
                    id,
                    data: formData,
                })
            ).unwrap();
            await dispatch(getUserInfo(id));
            toast.success("Profile updated successfully");
        } catch (error) {
            toast.error(error?.message || "Profile update failed");
        }
    };

    /* PASSWORD TOGGLE */

    const togglePasswordVisibility = () =>
        setPasswordVisible(!passwordVisible);
    const toggleConfirmPasswordVisibility = () =>
        setConfirmPasswordVisible(!confirmPasswordVisible);

    return (
        <div className="row gy-4">
            {/* LEFT PROFILE CARD */}

            <div className="col-lg-4">
                <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                    <img
                        src="/assets/images/user-grid-bg1.png"
                        alt=""
                        className="w-100 object-fit-contain"
                    />

                    <div className="pb-24 ms-16 mb-24 me-16 mt--100">
                        <div className="text-center border border-top-0 border-start-0 border-end-0">

                            <div style={{ position: "relative", display: "inline-block" }}>

                                <img
                                    src={imagePreview}
                                    className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-contain"
                                />

                                <label htmlFor="avatarUpload">

                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "10px",
                                            right: "10px",
                                            background: "#22c55e",
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer"
                                        }}
                                    >
                                        <Icon icon="mdi:camera" style={{ color: "#fff" }} />
                                    </div>

                                </label>

                                <input
                                    type="file"
                                    id="avatarUpload"
                                    hidden
                                    accept="image/*"
                                    onChange={handleImageSelect}
                                />

                            </div>

                            <h6 className="mb-0 mt-16">
                                {userInfo?.firstName} {userInfo?.lastName}
                            </h6>

                            <span className="text-secondary-light mb-16">
                                {userInfo?.email}
                            </span>
                        </div>

                        <div className="mt-24">
                            <h6 className="text-xl mb-16">Personal Info</h6>

                            <ul>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 fw-semibold">Full Name</span>
                                    <span className="w-70">
                                        : {userInfo?.fullName}
                                    </span>
                                </li>

                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 fw-semibold">Email</span>
                                    <span className="w-70">: {userInfo?.email}</span>
                                </li>

                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 fw-semibold">Phone</span>
                                    <span className="w-70">: {userInfo?.phone}</span>
                                </li>

                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 fw-semibold">Role</span>
                                    <span className="w-70">: {userInfo?.Role?.name}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* RIGHT PANEL */}

            <div className="col-lg-8">
                <div className="card h-100">
                    <div className="card-body p-12">

                        {/* TABS */}

                        <ul
                            className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center px-24 active"
                                    id="pills-edit-profile-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-edit-profile"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-edit-profile"
                                    aria-selected="true"
                                >
                                    Edit Profile
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center px-24"
                                    id="pills-change-passwork-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-change-passwork"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-change-passwork"
                                    aria-selected="false"
                                    tabIndex={-1}
                                >
                                    My Contacts
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center px-24"
                                    id="pills-assign-location-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-assign-location"
                                    type="button"
                                >
                                    Assign Location
                                </button>
                            </li>
                            {canAssignSponsors && (
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-assign-sponsor"
                                    >
                                        Assign Sponsors
                                    </button>
                                </li>
                            )}
                        </ul>

                        <div className="tab-content" id="pills-tabContent">

                            {/* EDIT PROFILE TAB */}

                            <div className="tab-pane fade show active" id="pills-edit-profile">

                                <h6 className="mb-16">Personal Info</h6>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <input
                                            className="form-control mb-16"
                                            name="email"
                                            type="email"
                                            disabled={isLoggedInSponsor}
                                            placeholder="Email"
                                            value={profileData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <small className="text-danger">{errors.email}</small>
                                        )}
                                    </div>

                                    <div className="col-sm-6">
                                        <div style={{ display: "flex", gap: "8px" }}>

                                            {/* Country Code */}
                                            <div style={{ width: "200px" }}>
                                                <Select
                                                    options={countryOptions}
                                                    value={countryOptions.find(c => c.value === profileData.countryCode)}
                                                    onChange={(selected) => {
                                                        setProfileData(prev => ({
                                                            ...prev,
                                                            countryCode: selected.value
                                                        }));
                                                    }}
                                                    styles={customStyles}
                                                    isDisabled={isLoggedInSponsor}
                                                    formatOptionLabel={formatOptionLabel}
                                                    isSearchable
                                                />
                                            </div>

                                            {/* Phone */}
                                            <input
                                                className="form-control mb-16"
                                                name="phone"
                                                type="text"
                                                disabled={isLoggedInSponsor}
                                                placeholder="Phone"
                                                value={profileData.phone}
                                                onChange={handleChange}
                                                maxLength={15}
                                            />

                                        </div>

                                        {errors.phone && (
                                            <small className="text-danger">{errors.phone}</small>
                                        )}
                                    </div>
                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="userName" value={profileData.userName} disabled={isLoggedInSponsor} onChange={handleChange} placeholder="User Name" />
                                    </div>

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="designation" placeholder="Designation" disabled={isLoggedInSponsor} value={profileData.designation} onChange={handleChange} />
                                    </div>

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="country" value={profileData.country} disabled={isLoggedInSponsor} onChange={handleChange} placeholder="Country" />
                                    </div>

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="city" value={profileData.city} disabled={isLoggedInSponsor} onChange={handleChange} placeholder="City" />
                                    </div>
                                </div>
                                {/* COMPANY INFO */}

                                <h6 className="mb-16">Company Info</h6>

                                <div className="row">

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="companyName" disabled={isLoggedInSponsor} placeholder="Company Name" value={profileData.companyName} onChange={handleChange} />
                                    </div>

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="workPhone" type="text" placeholder="Work Phone" value={profileData.workPhone} onChange={handleChange}
                                            maxLength={15}
                                            inputMode="numeric"
                                        />
                                        {errors.workPhone && (
                                            <small className="text-danger">{errors.workPhone}</small>
                                        )}
                                    </div>

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="workEmail" type="email" placeholder="Work Email" value={profileData.workEmail} onChange={handleChange} />
                                        {errors.workEmail && (
                                            <small className="text-danger">{errors.workEmail}</small>
                                        )}
                                    </div>

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="companyWebsite" placeholder="Company Website" value={profileData.companyWebsite} onChange={handleChange} />
                                    </div>

                                    <div className="col-12">
                                        <input className="form-control mb-16" name="companyAddress" placeholder="Company Address" value={profileData.companyAddress} onChange={handleChange} />
                                    </div>

                                    <div className="col-6">
                                        <textarea className="form-control mb-16" name="description" rows={4} placeholder="Description" value={profileData.description} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        {/* <label>Company Logo </label> */}

                                        <div className="upload-image-wrapper">
                                            <label
                                                htmlFor="logoUpload"
                                                className="upload-file border radius-8 border-dashed d-flex align-items-center justify-content-center"
                                                style={{ height: "120px", cursor: "pointer" }}
                                            >
                                                {logoPreview ? (
                                                    <img
                                                        src={logoPreview}
                                                        alt="logo"
                                                        className="w-100 h-100 object-fit-contain"
                                                    />
                                                ) : (
                                                    <div className="text-center">
                                                        <Icon icon="solar:camera-outline" width="24" />
                                                        <p className="mb-0">Upload Logo <small>(400x400)</small></p>
                                                    </div>
                                                )}
                                            </label>

                                            <input
                                                id="logoUpload"
                                                type="file"
                                                hidden
                                                accept="image/*"
                                                onChange={handleLogoChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <input className="form-control mb-16" name="room" placeholder="Booth No" value={profileData.room} onChange={handleChange} />
                                    </div>

                                    <div className="col-sm-6">
                                        {isSponsor && (
                                            isLoggedInSponsor ? (
                                                <input
                                                    className="form-control mb-16"
                                                    value={profileData.companyCategory || ""}
                                                    disabled
                                                />
                                            ) : (
                                                <select
                                                    className="form-control mb-16"
                                                    name="companyCategoryId"
                                                    value={profileData.companyCategoryId || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select Category</option>
                                                    {categories?.map((cat) => (
                                                        <option key={cat.id} value={cat.id}>
                                                            {cat.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )
                                        )}
                                    </div>

                                    {/* {isSponsor && (
                                        <div className="col-sm-6">
                                            <label>
                                                <small>No of Representative allowed</small>
                                            </label>

                                            <input
                                                type="number"
                                                className="form-control mb-16"
                                                name="allowed"
                                                value={profileData.allowed}
                                                min="0"
                                                max="99"
                                                disabled={isLoggedInSponsor}
                                                onChange={(e) => {
                                                    if (isLoggedInSponsor) return;

                                                    let value = Number(e.target.value);

                                                    if (value > 99) {
                                                        toast.error("Max allowed is 99");
                                                        value = 99;
                                                    }

                                                    if (value < 0) value = 0;

                                                    setProfileData({
                                                        ...profileData,
                                                        allowed: value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    )} */}

                                </div>

                                {/* SOCIAL INFO */}

                                <h6 className="mt-24 mb-16">Social Links</h6>

                                <div className="row">

                                    <div className="col-sm-6">
                                        <input
                                            className="form-control mb-16"
                                            name="linkedIn"
                                            placeholder="LinkedIn URL"
                                            value={profileData.linkedIn}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-sm-6">
                                        <input
                                            className="form-control mb-16"
                                            name="twitter"
                                            placeholder="Twitter URL"
                                            value={profileData.twitter}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-sm-6">
                                        <input
                                            className="form-control mb-16"
                                            name="instagram"
                                            placeholder="Instagram URL"
                                            value={profileData.instagram}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-sm-6">
                                        <input
                                            className="form-control mb-16"
                                            name="facebook"
                                            placeholder="Facebook URL"
                                            value={profileData.facebook}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-sm-6">
                                        <input
                                            className="form-control mb-16"
                                            name="website"
                                            placeholder="Personal Website"
                                            value={profileData.website}
                                            onChange={handleChange}
                                        />
                                    </div>

                                </div>

                                <h6 className="mt-24 mb-16">Uploads</h6>

                                <div className="row">

                                    {/* BANNER */}
                                    <div className="col-md-6 mb-3">

                                        <label>Banner <small className="fst-italic">(Only image-16:9 )</small></label>

                                        <div className="upload-image-wrapper d-flex align-items-center gap-3">

                                            <label
                                                htmlFor="bannerUpload"
                                                className="upload-file border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 d-flex align-items-center flex-column justify-content-center"
                                                style={{ width: "100%", height: "120px", cursor: "pointer" }}
                                            >

                                                {bannerPreview ? (
                                                    <img
                                                        src={bannerPreview}
                                                        alt="banner"
                                                        className="w-100 h-100 object-fit-contain"
                                                    />
                                                ) : (
                                                    <>
                                                        <Icon icon="solar:camera-outline" width="24" />
                                                        <span>Upload Banner</span>
                                                    </>
                                                )}

                                            </label>

                                            <input
                                                id="bannerUpload"
                                                type="file"
                                                hidden
                                                accept="image/*"
                                                name="banner"
                                                onChange={handleFileChange}
                                            />

                                        </div>

                                    </div>

                                    {/* PORTFOLIO */}
                                    <div className="col-md-6 mb-3">

                                        <label>Portfolio <small className="fst-italic">(Only image,pdf,ppt max 20mb)</small> </label>

                                        <div className="upload-image-wrapper d-flex align-items-center gap-3">

                                            <label
                                                htmlFor="portfolioUpload"
                                                className="upload-file border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 d-flex align-items-center flex-column justify-content-center"
                                                style={{ width: "100%", height: "120px", cursor: "pointer" }}
                                            >

                                                {portfolioPreview ? (
                                                    <img
                                                        src={portfolioPreview}
                                                        alt="portfolio"
                                                        className="w-100 h-100 object-fit-contain"
                                                    />
                                                ) : (
                                                    <>
                                                        <Icon icon="solar:camera-outline" width="24" />
                                                        <span>Upload Portfolio</span>
                                                    </>
                                                )}

                                            </label>

                                            <input
                                                id="portfolioUpload"
                                                type="file"
                                                hidden
                                                accept=".jpg,.jpeg,.png,.webp,.pdf,.ppt,.pptx"
                                                name="portfolio"
                                                onChange={handleFileChange}
                                            />

                                        </div>

                                    </div>

                                </div>

                                <div className="text-center mt-24">
                                    <button
                                        className="btn btn-primary px-56 py-12 radius-8"
                                        onClick={handleUpdateProfile}
                                    >
                                        Save Profile
                                    </button>
                                </div>

                            </div>

                            <div className="tab-pane fade" id="pills-change-passwork" role="tabpanel" aria-labelledby="pills-change-passwork-tab" tabIndex="0">
                                <MyContacts userId={id} />
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-assign-location"
                            >
                                <AssignLocationComponent userId={id} isLoggedInSponsor={isLoggedInSponsor} />
                            </div>
                            <div className="tab-pane fade" id="pills-assign-sponsor">
                                <AssignSponsorComponent sponsorId={id} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {showCropModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.5)",
                        zIndex: 9999
                    }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5>Crop Image</h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setShowCropModal(false)}
                                />
                            </div>

                            <div className="modal-body text-center">

                                {cropSrc && (
                                    <ReactCrop
                                        crop={crop}
                                        onChange={(c) => setCrop(c)}
                                        onComplete={(c) => setCompletedCrop(c)}
                                        aspect={1}
                                    >
                                        <img
                                            ref={imgRef}
                                            src={cropSrc}
                                            alt="crop"
                                            style={{ maxHeight: "400px" }}
                                        />
                                    </ReactCrop>
                                )}

                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleCropUpload}
                                >
                                    Upload
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>

    );
};

export default ViewProfileLayer;